// extracted by mini-css-extract-plugin
module.exports = {"header":"i_ej","body":"i_ek","content":"i_el","image":"i_em"};